import React from "react";
import PropTypes from "prop-types";
import { HeroImage } from "../../Atoms/HeroImage";
import "./imagewithanchor.m.css";
import { Link } from "@quintype/components";
import { isExternalStory, getStoryUrl } from "../../../utils/utils";
import { Headline } from "../../Atoms/Headline";
import { AuthorWithTime } from "../../Atoms/AuthorWithTimestamp";
import { Subheadline } from "../../Atoms/Subheadline";

function ImagewithAnchor({ aspectRatio, story, config, headerLevel, showMultipleAuthor, showAuthorContent, prefix, hideAuthorImage, mainCardImg = false, isFeaturedImage = false, addFreeCard = false }) {
  const { localizationConfig = {} } = config;

  return (
    <div styleName={mainCardImg ? 'mainCardimg' : 'storycardbox'}>
      <Link
        className="arr--hero-image"
        data-test-id="arr--hero-image"
        href={getStoryUrl(story, `/${story.slug}`)}
        externalLink={isExternalStory(story)}
        aria-label="fallback-hero-image"
        disableAjaxLinks={true}
      >
        <HeroImage
          config={config}
          story={story}
          isHorizontal
          aspectRatio={aspectRatio}
          FullBleed={true}
          noHyperlink
          isFeaturedImage={isFeaturedImage}
        />
        <div styleName={mainCardImg ? 'mainCardheading' : ''}>
          <Headline story={story} headerLevel={headerLevel} isLink={false} premiumStoryIconConfig={config} addFreeCard={addFreeCard} />
          <AuthorWithTime
            config={localizationConfig}
            story={story}
            isBottom
            prefix={prefix}
            hideAuthorImage={hideAuthorImage}
            separator="divider"
            showMultipleAuthor={showMultipleAuthor}
            showAuthorContent={showAuthorContent}
            showTimeStamp={false}
          />
          <Subheadline story={story} isHidesubheadline={false} />
        </div>
      </Link>
    </div>
  );
}

export default ImagewithAnchor;
